type SurveyOrigins = {
  [key: string]: {
    name: string
    color: string
  }
}

export const SURVEY_ORIGINS: SurveyOrigins = {
  TOTEM: {
    name: 'Totem',
    color: 'blue',
  },
  FISICA: {
    name: 'Física',
    color: 'purple',
  },
  PHYSICAL: {
    name: 'Física',
    color: 'purple',
  },
  ATTENDANCE: {
    name: 'Atendimento',
    color: 'green',
  },
  FIELD_ATTENDANCE: {
    name: 'Atendimento em campo',
    color: 'cyan',
  },
  BROWSER: {
    name: 'Navegador',
    color: 'purple',
  },
  MODULE: {
    name: 'Módulo',
    color: 'red',
  },
  UNKNOWN: {
    name: 'Desconhecida',
    color: 'gray',
  },
}
